import React, { useState } from 'react';
import { Button, ButtonColors, Modal, Typography } from '@repo/ui';

interface UnnecessarySurveysModalProps {
  onClose: () => void;
  onConfirm: () => void;
  isOpen: boolean;
  title: string;
  description: string;
}

const UnnecessarySurveysModal: React.FC<UnnecessarySurveysModalProps> = ({
  onClose,
  onConfirm,
  isOpen,
  title,
  description,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} showHeader>
      <div className='flex flex-column align-items-center gap-3 py-2 text-center'>
        {/* <Typography variant='heading-xl'>{title}</Typography> */}
        <Typography variant='heading-s'>
          Editing this answer will make the following survey no longer
          necessary, even though you've already completed it.
        </Typography>
        <Typography variant='heading-s'>
          If you confirm this change, your responses to the survey listed below
          will be deleted:
        </Typography>
        <Typography variant='heading-s'>
          {description.replace('Surveys that are no longer needed:', '')}
        </Typography>
        <div className='flex flex-column align-items-center gap-3 mt-4'>
          <Button
            color={ButtonColors.PURPLE}
            onClick={handleConfirm}
            width='full'
            loading={isLoading}
          >
            Confirm edit and delete survey
          </Button>
          <Button
            onClick={onClose}
            color={ButtonColors.LIGHT}
            width='full'
            disabled={isLoading}
          >
            Keep current answer
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UnnecessarySurveysModal;
